import { HttpLink } from '@apollo/client';
import { GRAPHQL_URI } from '../util';

export const httpLink = new HttpLink({ uri: GRAPHQL_URI });
